/* eslint-disable prettier/prettier */
import { Vue, RightHelper, AxiosResponse, EnumsService, Prop, Vuex, Watch, tlISODateTimeToLocalNoSecondsString } from "./CoreBase";
import { BTable } from 'bootstrap-vue';
import { Dictionary } from "vue-router/types/router";
import { Store } from "vuex";


interface IFilter {
	key: '',
	label: '',
	selected: boolean, 
	value: null | Date | Number | String | any,
	type: String,
	enum: '',
	useEnum: false,
	moreThan: false,
	onlyShow: false,
	group: boolean,
	groupId: '',
	isNegative: boolean,
	isDetail: boolean,
	lang: String
	default: ''
}

interface IOptionalColumn {
	defaultVisible: false,
	selected: false,
	value: '',
	text: ''
}
export default abstract class BaseTLTableBase extends Vue {

	protected gridFieldsBase: any;
	protected fieldsBase: any;
	protected filtersBase: any;
	protected itemsDataBase: any;

	protected selectedMultiNamesBase: any;

	protected selectedBase = false;
	protected designBase = '';
	protected nameBase = '';
	protected defaultSortByBase = '';
	protected defaultSortDescBase = false;
	protected showInModalBase = false;
	protected notChangeUrlBase = false;

	//zde se ulozi query kterou nechceme aby zmenila zmena filtru napr. u settingList - zatim to neni vyreseno
	protected queryBase: any;
	//puvodni query nez se zacne zpracovavat u filtru
	protected firstCurrentPage = 0;
	protected queryFirst: any;

	protected selectedRowMain: number[] = []; // seznam Id vybraných indexu
	enumsService: EnumsService = new EnumsService();

	protected afterInit: boolean = false;

	heightTable = "200px";

	isGridShow = false;
	perPage = 50;
	totalRows = 0;
	currentPage = 1;
	currentPageCount = 1; //to je pro moznost zvysovat pridani dalsi zaznamy
	countNextPageNotChangeBack = true;
	oldCurrentPage = 0;
	countNextPage = 1;     //pocet dalsich zaznamu na strance
	pageOptions = [10, 20, 50, 100];
	sortDesc = true;
	sortBy = 'id';
	filter = '';
	filterOn = [''];
	filterOn2 = [''];
	sortDirection = 'desc';

	restTable = false;

	optionsMultiselect = [];
	selectedAllItems = false;
	selectedItemsMain: any[] = []; //seznam vybraných prvku
	selectedItemsName: any[] = []; //jmena u zobrazených

	filterNotShow = 'notShow'; //filter, který se vždy vyhodnocuje a nemá value např. isDeleted
	onlyShow = false; // zobrazení pouze info
	protected onlyOneBase = false; // výběr pouze jednoho prvku

	isBusy = true;
	selectedFilter: IFilter[] = [];
	filterData: IFilter[] = [];

	useTooltip = false;

	//TODO jak zjisti aktualni sirku sloupce
	maxWidthTagColumn = 30;

	selectedColumnsVisibility: any[] = []; // aktualne zobrazene sloupce
	selectedColumns: any[] = [];
	optionsColumns: any[] = [];
	tooltipsColumns: any[] = [];

	showColumnSetting = false;
	showFilterSetting = false;

	lastIdComponent = 0;

	public clearSelected(): void {
		//this.selectedRowMain = [];
		this.deselectAll();
	}
	

	//při zmene jazyka je potreba zde zmenit nazvy sloupců
	//@ts-ignore
	@Watch('$i18n.locale')
	changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
		if (value !== oldValue) {		
			for (var i = 0; i < this.fieldsBase.length; i++) {
				if (this.fieldsBase[i].trans != undefined) {
					this.fieldsBase[i].label = this.$t(this.fieldsBase[i].trans);
				}
			}
			for (var i = 0; i < this.filtersBase.length; i++) {
				if (this.filtersBase[i].trans != undefined) {
					this.filtersBase[i].label = this.$t(this.filtersBase[i].trans);
				}
			}
	
			for (var i = 0; i < this.gridFieldsBase.length; i++) {
				if (this.gridFieldsBase[i].trans != undefined) {
					
					this.gridFieldsBase[i].label = this.$t(this.gridFieldsBase[i].trans);
				}
			}
			this.initOptionsColumns();
		}
	}


	// #region Component events

	//nacteni filtru z query musim s tim pockat az do akce beforeUpdate kdy uz jsou jasne filtry
	isLoadFilterAfterBefore = true;

	created() {		

		this.isGridShow = this.designBase == 'detail' ? false : this.storeFrom(this.$store.state.isShowGrid);
		this.sortBy = this.storeFrom(this.$store.state.sortBy);
		this.sortDesc = this.storeFrom(this.$store.state.sortDesc);
		this.totalRows = this.storeFrom(this.$store.state.totalRows);
		this.perPage = this.storeFrom( this.$store.state.perPageTable);		

		
		this.perPage = this.$store.state.perPage;

		if (this.pageOptions.indexOf(Number(this.perPage)) == -1) {
			this.perPage = this.pageOptions[0];
		}
		
		if (this.storeFrom(this.$store.state.perPageTable) != -1) {
			this.perPage = this.storeFrom(this.$store.state.perPageTable);
		}

		this.currentPage = this.storeFrom(this.$store.state.currentPage);
		this.firstCurrentPage = this.storeFrom(this.$store.state.currentPage);

		if (!this.showInModalBase) {
			this.queryFirst = this.$route.query;
		}
		

		this.initTooltipColumns();
		//nacteni filtrů

		//primy odkaz  tu jeste nenma filtry		
		if (this.$route.query != null) {
			this.isLoadFilterAfterBefore = false;
		}
		
		let loadFilters = this.storeFrom(this.$store.state.filterAll);

		if ((this.restTable && loadFilters == null)) {
			loadFilters = this.filtersBase;	
		
			var hodnoty = JSON.stringify(this.$store.state.lastRoutePageQuery);
			var loadFiltersQuery = this.loadFiltersFromQuery(loadFilters, this.optionsColumns,hodnoty);
			this.$emit('loadFilters', loadFiltersQuery);

			this.isLoadFilterAfterBefore = true;
		}

		if (loadFilters != null) {
			this.$emit('loadFilters', loadFilters);
		}
		
		//nastavení defaultní filtru
		if (this.sortBy == '') {
			this.sortBy = this.defaultSortByBase || '';
			this.sortDesc = this.defaultSortDescBase;		
		}

		if (this.sortBy != '') {
			this.sortChanged();
		}

		//jestli jsou některé cloupce z definice neviditelné
		var listHideColumns = this.fieldsBase.filter((c: any) => c.show == false);

		//skryti pomocných sloupců co nemaji byt videt
		for (var i = 0; i < listHideColumns.length; i++) {
			this.changeVisibility(listHideColumns[i].key, false);
		}

		// zobrazeni sloupcu, ktere maji byt videt bud dle toho co uzivatel naklikal nebo je podle nastaveni viditelne	
		var selectColumns = this.storeFrom(this.$store.state.selectedColumns);
		if (selectColumns != null) {
			this.selectedColumns = selectColumns;
		}

		if (this.selectedColumns != null) {
			for (var i = 0; i < this.optionsColumns.length; i++) {
				var isVisible = this.selectedColumns.indexOf(this.optionsColumns[i].value) != -1;
				this.changeVisibility(this.optionsColumns[i].value, isVisible);
			}
		}

		this.initOptionsColumns();

		//TODO nevim jak vypnout tocici se kolo, tak radsi ho vypnu uplně
		//jak to nastane vyplnim filtr, prepnu na jionu stranku, vrátim se a kdyz neexistuji zadne zaznamy
		if (loadFilters != null) {
			//VaPTODO - zde to nefungovalo pro znovu zobrazeni stranky. Bude potreba cely ten model isbusy a isbusyshow predelat, at to funguje lepe
			//        - hlavne spousta nastaveni isbudy je uplne zbytecnych, jelikoz se zapinaji, i kdyz <template slot="empty"> neni zobrazen
			//        - tim padem nefunguje ani zobrazeni spinneru kdyz se zapina filtr nebo se filtruji data, takze zde je to zobrazovani zbytecne
			//        - podle meho i vlastni isbusyshow je zbytecne a dalo by se zrusit
			//this.isBusy = false;
		}
	}

	actualFilter = '';
	firstQuery = '';

	beforeUpdate() {		
			let loadFilters = this.storeFrom(this.$store.state.filterAll);

		let optionsColumns = this.storeFrom(this.$store.state.optionsColumns);

		if (this.firstQuery == '' && this.isLoadFilterAfterBefore == false) {
			this.firstQuery = JSON.stringify(this.$route.query);			
		}
		
		if (loadFilters != null) {	
			// varianta kdyz se urcite filtry nactou az pozdeji Groups (nacitaji se z ciselniku)
			if (this.actualFilter != JSON.stringify((loadFilters as Array<any>).length)) {
			
				this.actualFilter = JSON.stringify((loadFilters as Array<any>).length);
				if (!this.restTable) {
					this.isLoadFilterAfterBefore = false;
				}
			}
			//REST Vyjimak
			if (this.isLoadFilterAfterBefore == false && !this.showInModalBase && this.restTable == false) {				
				var loadFiltersQuery = this.loadFiltersFromQuery(loadFilters, this.optionsColumns, this.firstQuery);
				
				this.isLoadFilterAfterBefore = true;
				
				if (JSON.stringify(loadFilters) != JSON.stringify(loadFiltersQuery)) {
					this.$emit('loadFilters', loadFiltersQuery);
				}
			}

			//TODO TAGY proverit proc to hazelo error
			//var tags = (loadFilters as Array<any>).filter(c => c.key == 'tags');
			
			//if (tags.length > 0) {
			//	if (tags[0].value != null) {
			//		(this.$refs.tags as Array<any>)[0].initMulti(tags[0].value);
			//	}
			//}
		}
	}

	setShowInModalBase() {
		this.showInModalBase = true;
	}

	setNotChangeUrlBase() {
		this.notChangeUrlBase = true;
	}



	onlyOneAfterUpdate = true;
	loadCurrentPage = 1;
	afterUpdate() {
	if (this.totalRows > 0 && !this.showInModalBase && !this.notChangeUrlBase ) {
		if (this.queryFirst != null && this.queryFirst['currentPage'] != undefined) {
			
			this.loadCurrentPage = Number(this.queryFirst['currentPage']);
			var currentPerPageFromQuery = Number(this.queryFirst['perPage']);
			//kontrola jestli neni uplne mimo rozsah pageOptions
			if (!this.pageOptions.some((c: number) => c == currentPerPageFromQuery)) {				
				currentPerPageFromQuery = this.pageOptions[0];
			}
				this.perPage = currentPerPageFromQuery;
			this.$store.commit("perPageTable", { name: this.nameBase, value: this.perPage });
				var currentPageFromQuery = Number(this.queryFirst['currentPage']);
				if (currentPageFromQuery * this.perPage > this.totalRows) {
					currentPageFromQuery = 1;
					this.loadCurrentPage = 1;
				}
			this.currentPage = currentPageFromQuery;
			this.$store.commit("currentPage", { name: this.nameBase, value: this.currentPage });
				this.queryFirst = null;
				this.firstCurrentPage = 0;
			}
			else if (this.firstCurrentPage > 0 && (this.queryFirst == null || Object.keys(this.queryFirst).length === 0) && !this.showInModalBase) {		
				this.currentPage = this.firstCurrentPage;
			this.$store.commit("currentPage", { name: this.nameBase, value: this.currentPage });
				this.firstCurrentPage = 0;
			}	
			//tohle je zmena stranky musi byt udelana takto protoze pokud se zmeni pocet na stranku tak se to na stavi na currentPage na 1
			else if (this.loadCurrentPage != 1 && this.onlyOneAfterUpdate) {
				this.onlyOneAfterUpdate = false;
				this.$nextTick(function () {
					this.currentPage = this.loadCurrentPage;
					this.$store.commit("currentPage", { name: this.nameBase, value: this.currentPage });
					this.loadCurrentPage = 1;
				});
				
			}
		}
    }

	// #endregion

	select() {
		if (this.selectedAllItems) {
			this.selectAll();
		}
		else {
			this.deselectAll();
		}
	}

	public deselectAll() {
		this.selectedAllItems = false;
		this.selectedItemsMain = [];
		this.selectedItemsName = [];
		this.selectedRowMain = [];
	}

	isSelectedRow(data: any) {
		return this.selectedRowMain.indexOf(data.item.id) >= 0;
	}

	selectAll() {
		this.selectedAllItems = true;
		this.selectedItemsMain = [];
		this.selectedItemsName = [];
		this.selectedRowMain = [];
		const resFilter = this.filterItems();
		for (var i = 0; i < resFilter.length; i++) {
			this.clickRow(resFilter[i].id, false);
		}
	}

	//vybrani vsech polozek na aktualni strance
	selectAllPage() {
		this.selectedAllItems = true;
		this.selectedItemsMain = [];
		this.selectedItemsName = [];
		this.selectedRowMain = [];
		const resFilter = this.filterItems();
		var items = (this.filterItems() as Array<any>);
		//je potreba je setridit
		if (this.sortDesc) {
			items = items.sort((a: any, b: any) => (b[this.sortBy] ? b[this.sortBy].localeCompare(a[this.sortBy]) : -1));
		}
		else {//nahoru sipka asc
			items= items.sort((a: any, b: any) => (a[this.sortBy] ? a[this.sortBy].localeCompare(b[this.sortBy]) : -1));
		}


		var min = this.perPage * (this.currentPage - 1);
		var max = min + this.perPage ;
		max = max > items.length ? items.length : max;
		for (var i = min; i < max; i++) {
			this.clickRow(resFilter[i].id, false);
		}
	}


	filterItems() {
		let returnAllItems = false;
		let result: any[] = [];

		if (this.filtersBase == null || this.filtersBase == undefined) {
			this.filtersBase = []; //NOVINKA
			returnAllItems = true;
		}

		if (returnAllItems === false) {
			this.filterData = this.filtersBase;

			//v případě že existuje filter s onlyShow přepnutí pouze do info
			this.onlyShow = this.filterData.filter(c => c.selected && c.type === this.filterNotShow).length > 0;

			// VaP - ma vubec cenu filtrovat?
			let selFilters = this.filterData.filter(c => (c.selected && c.value) || c.type.toString() == this.filterNotShow
				|| (!c.selected && c.groupId != ''));

			if (selFilters.length == 0) {
				returnAllItems = true;
			}
		}

		// VaP - mame co filtrovat
		if (returnAllItems === false) {
			result = this.GetFilteredData();
		}

		if (returnAllItems) {
			this.totalRows = this.itemsDataBase.length;
			return this.itemsDataBase;
		}
		else {
			this.totalRows = result.length;
			this.$emit('changeFilter', 'zmena');
		
			//uprava URL i s filtrem i viditelnost sloupců
			if (this.isLoadFilterAfterBefore == true && this.showInModalBase == false && !this.notChangeUrlBase) {
				var newQuery = this.prepareFiltersToQuery();
				if (JSON.stringify(this.$route.query) != JSON.stringify(newQuery)) {
					var namePage = this.$route.name == undefined ? '' : this.$route.name;
					this.$router.replace({ name: namePage, query: newQuery });
				}
			}
	
			this.$store.commit("filterAll", { name: this.nameBase, value: this.filtersBase });
			return result;
		}
	}

	
	
	filterItemsRest() {
		
		if (this.isLoadFilterAfterBefore == true &&  this.showInModalBase == false && !this.notChangeUrlBase) {
			var newQuery = this.prepareFiltersToQuery();
			if (JSON.stringify(this.$route.query) != JSON.stringify(newQuery)) {
				var namePage = this.$route.name == undefined ? '' : this.$route.name;
				this.$router.replace({ name: namePage, query: newQuery });
				this.$store.commit("filterAll", { name: this.nameBase, value: this.filtersBase });				
			}
		}
		this.$store.commit("filterAll", { name: this.nameBase, value: this.filtersBase });
	}

	//nacitani z url query filru, viditelnost column a zobrazeni v gridu
	loadFiltersFromQuery(filters: IFilter[], optionalColumn: IOptionalColumn[], firstQuery: string) {
		if (!this.showInModalBase) {	
			var firstQ = JSON.parse(firstQuery);
			var newQuery = this.prepareFiltersToQuery();
			if (JSON.stringify(this.$route.query) != JSON.stringify(newQuery)) {
				//nacteni volitelných sloupců
				for (var a = 0; a < optionalColumn.length; a++) {
					//@ts-ignore
					var name = this.optionsColumns[a].value + this.visibilityUrl;
					if (this.$route.query[name] != undefined) {
						var opt = String(optionalColumn[a].selected);
						var route = (this.$route.query[name]) ? 'true' : 'false';
						if (opt != route) {
							(optionalColumn[a].selected as boolean) = route == 'true' ? true : false;
							this.changeVisibility(this.optionsColumns[a].value, optionalColumn[a].selected);
						}
					}
				}
				
				//ulozeni sloupců
				this.$store.commit("optionsColumns", { name: this.nameBase, value: this.optionsColumns });

				for (var i = 0; i < filters.length; i++) {
				

					//varianta groups
					if (firstQ[filters[i].key] != undefined) {
						if (filters[i].group == true) {
							var isNegative = filters[i].isNegative; //kdyz je negativni 
							var nalez = firstQ[filters[i].key] as string;
							
							var isSel = nalez.startsWith('!');
							isSel = isNegative ? !isSel : isSel;
							(filters[i].selected as boolean) = isSel;
						}
					}

					if (this.$route.query[filters[i].key] != undefined) {
						//TODO ta podminka
						if (filters[i].value != this.$route.query[filters[i].key] && !(filters[i].group && this.restTable)) {
							(filters[i].selected as boolean) = true;
							if (filters[i].type == "multi") {
								// tady nacist tagy
								var res = [];
								var tagsQ = String(this.$route.query[filters[i].key]).split('&|&');
								for (var gh = 0; gh < tagsQ.length; gh++) {
									res.push(JSON.parse(tagsQ[gh]));
                                }
								filters[i].value = res;
							}
							//else if (filters[i].group == true) {
						           
							////	//var isNegative = filters[i].isNegative; //kdyz je negativni 
							////	////var nalez = this.$route.query[filters[i].key];					

							////	//filters[i].value = false;
							//}
							else { 
								filters[i].value = this.$route.query[filters[i].key];
							}
						}
					}
				}
				if (this.$route.query['isGridShow'] == 'true') {
					this.changeShowDesign(true);
				}
			}
		}

        return filters;
	}

	//viditelnost sloupcu prevod do url-POUZIVA SE?
	prepareColumnVisibilityToQuery() {
		var result = {};
	
        for (var i = 0; i < this.optionsColumns.length; i++) {
			if (this.optionsColumns[i].selected != this.optionsColumns[i].defaultVisible ) {
                var name = this.optionsColumns[i].value;
                var val = this.optionsColumns[i].selected == null ? '' : this.optionsColumns[i].selected.toString();
                //@ts-ignore
                result[name] = val;
            }
        }
		return result;
    }

	visibilityUrl = 'Visibility';
	//fitr prevod do url i viditelnost sloupců
	prepareFiltersToQuery() {
		var result = {};
		if (this.queryBase != undefined && this.queryBase != null) {
			result = this.queryBase;
		}
		//filtry
		for (var i = 0; i < this.filtersBase.length; i++) {
			//group je specificky
			var name = this.filtersBase[i].key;
			if (this.filtersBase[i].group == true) {
				var vybrfano = this.filtersBase[i].selected;
			
				//@ts-ignore
				result[name] = vybrfano == true ? this.filtersBase[i].value.toString() : '!' + this.filtersBase[i].value.toString();
				
			}
			else if (this.filtersBase[i].selected) {
				/*var name = this.filtersBase[i].key;*/
				if (this.filtersBase[i].type == 'multi') {
					if (this.filtersBase[i].value != null) {
						var valMulti = this.filtersBase[i].value as Array<any>;
						var multiString = ''; 
						if (valMulti.length > 0) {
							for (var ak = 0; ak < valMulti.length; ak++) {
								var multiString = valMulti.map(obj => JSON.stringify({ id: obj.id, color: obj.color, name: obj.name })).join('&|&');
                            }
						}

						//@ts-ignore
						result[name] = multiString;
					}
				}			
				else {
					var val = this.filtersBase[i].value == null ? '' : this.filtersBase[i].value.toString();
					//@ts-ignore
					result[name] = val;
				}
            }
		}
		//viditelnost sloupců
		for (var i = 0; i < this.optionsColumns.length; i++) {
			if (this.optionsColumns[i].selected != this.optionsColumns[i].defaultVisible) {
				//@ts-ignore
				var name = this.optionsColumns[i].value + this.visibilityUrl;
				var val = this.optionsColumns[i].selected == null ? '' : this.optionsColumns[i].selected.toString();
				//@ts-ignore
				result[name] = result[name] == null ? val : result[name];
			}
		}

		//grid
		if (this.isGridShow) {
			//@ts-ignore
			result['isGridShow'] = this.isGridShow;
		}
	if (this.currentPage>0 ) {
			//@ts-ignore
			result['currentPage'] = String(this.currentPage);
		}

		if (this.perPage > 0) {
			//@ts-ignore
			result['perPage'] = String(this.perPage);
		}
		return result;
    }

	useFilters() {
		if (this.filtersBase == undefined) {
			return null;
		}
		this.filterData = this.filtersBase;

		//nastavení základního data
		for (var i = 0; i < this.filterData.length; i++) {
			if (this.filterData[i].value == null && this.filterData[i].type.toString() == 'datetime'
				&& this.filterData[i].default == undefined) {

				var actualDate = new Date();
				if (this.filterData[i].moreThan) {
					actualDate.setHours(0);
					actualDate.setMinutes(0);
				}
				else {
					actualDate.setHours(23);
					actualDate.setMinutes(59);
				}
				this.filterData[i].value = actualDate;
			}
		}

		return this.filterData.filter(c => (c.type.toString()) != this.filterNotShow && c.default == undefined);
	}

	doubleClickRow(item: any, index: any) {
		this.$emit('doubleClickRow', item, index, this.selectedItemsMain);
		this.$emit('selectItems', this.selectedItemsMain);
	}

	clickRow(id: any, isClick: boolean) {	
		if (this.selectedBase) {		
			if (this.onlyOneBase == true) {
				this.selectedRowMain = [];
				this.selectedItemsName = [];
				if (isClick == false) {
					return;
				}
			}

			var index = this.selectedRowMain.indexOf(id);
			if (index == -1) {
				this.selectedRowMain.push(id);
				var item = (this.itemsDataBase as [any]).filter(c => c.id == id)[0];

				var itemsName = '';
				if (this.selectedMultiNamesBase != null) {
					for (var i = 0; i < this.selectedMultiNamesBase.length; i++) {
						itemsName += item[this.selectedMultiNamesBase[i]] + ' ';
					}
					this.selectedItemsName.push({ id: id, name: itemsName });
				}
				this.selectedItemsMain.push(item);

			}
			else {
				this.selectedRowMain.splice(index, 1);
				//this.selectedRowMain.splice(this.selectedRowMain.indexOf((c: any) => c.id == id), 1);
				this.selectedItemsMain = this.selectedItemsMain.filter((c: any) => c.id != id);
				if (isClick) {
					var index = 0;
					for (var i = 0; i < this.selectedItemsName.length; i++) {
						if (this.selectedItemsName[i].id == id) {
							break;
						}
						index++;
					}
					this.selectedItemsName.splice(index, 1);
				}
			}
		}
		this.$emit('selectItems', this.selectedItemsMain);
	}

	private GetFilteredData(): any[] {
		let filteredDatat: any[] = [];
		if (this.itemsDataBase) {
			for (var element of this.itemsDataBase) {
				if (this.isOkRowByFilter(element)) {
					filteredDatat.push(element);
				}
			}
		}
		return filteredDatat;
	}

	isOkRowByFilter(rowItem: any) {
		if (this.fieldsBase == null || this.fieldsBase == undefined) {
			return true;
		}

		this.filterData = this.filtersBase;

		let isOk: boolean = true;
		//filtry ktere nejsou v group
		let selFilters = this.filterData.filter(c => (c.selected || c.type.toString() == this.filterNotShow) && !c.group);
		let selFiltersGroup = this.filterData.filter(c => (c.selected || c.type.toString() == this.filterNotShow) && c.group);
		let countGroup = this.filterData.filter(c => c.group);
		if (countGroup.length > 0 && selFiltersGroup.length == 0) {
			return false;
		}
		if (selFilters.length > 0) {

			let rowObject = Object(rowItem);

			for (var i = 0; i < selFilters.length; i++) {
				let filter = selFilters[i];
				let useEnum = filter.useEnum ? true : false;
				let filterType = filter.type.toString();
				if ((filter.value == null || isOk == false || filter.value == '') && filterType != this.filterNotShow) {
					continue;
				}

				// problem s prevodem null na string
				let filterValue = filter.value;
				let filterValueString = '';
				if (filterValue) {
					filterValueString = filterValue as string;
				}

				//specialni filtr, který se vyhodnucuje pokazde
				if (filterType == this.filterNotShow) {
					isOk = isOk && (rowObject[filter.key] as boolean) == filter.selected;
				}

				if (filterType == 'text') {

					if (useEnum) {
						if (filter.isNegative) {
							isOk = isOk && rowObject[filter.key] != filter.value;
						}
						else {
							isOk = isOk && rowObject[filter.key] == filter.value;
						}
					}
					else {
						let fin = filterValueString;
						var controlRow = filter.isDetail ? (rowObject[filter.key] as any).name  : (rowObject[filter.key] as string);
						if (controlRow == null) {
							isOk = false;
						}
						else {
							//	ODKOMENTOVAT AZ ZAPLATI 252 uz jsem to pouzil #1096

							let ignore = this.$store.state.ignoreDiacritics as boolean;
							if (ignore == true || this.$store.state.ignoreDiacritics == 'true') {
								let main = (controlRow as string).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
								isOk = isOk && main.indexOf(fin.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) != -1;
							}
							else {
								let main = (controlRow as string).toLowerCase();
								isOk = isOk && main.indexOf(fin.toLowerCase()) != -1;
							}
						}
					}
				}
				else if (filterType == 'datetime') {
					let filterDate = new Date((filter.value as string));
					let itemDate = new Date(rowObject[filter.key] as string);

					isOk = isOk && filter.moreThan ? itemDate >= filterDate : itemDate <= filterDate;
				}
				else if (filterType == 'date') {
					let filterDateNum = this.prepareForNumber(filter.value);
					let valueDateNum = this.prepareForNumber(rowObject[filter.key]);
					isOk = isOk && filter.moreThan ? valueDateNum >= filterDateNum : valueDateNum <= filterDateNum && valueDateNum != -1;
				}
				else if (filterType == 'number') {
					let filterNum = Number(filter.value);
					let valueNum = Number(rowObject[filter.key]);
					isOk = isOk && filter.moreThan ? valueNum >= filterNum : valueNum <= filterNum && valueNum != -1;
				}
				else if (filterType == 'time') {
					let dateFilter = new Date('1/1/1999 ' + filter.value + ':00');
					//let dateControl = new Date('1/1/1999 ' + (Object(this.itemsDataBase[item])[filter.key] as string) + ':00');
					let dateControl = new Date('1/1/1999 ' + (rowObject[filter.key] as string));

					isOk = isOk && filter.moreThan ? dateControl >= dateFilter : dateFilter >= dateControl;
				}
				else if (filterType == 'multi') {
					//TODO lepsi sestaveni algoritmu
					var multiObjectsList = filter.value as Array<any>;
					var findMulti = true;
					var existAnd = false;
					var findAnd = false;
					for (var i = 0; i < multiObjectsList.length; i++) {
						
						if ((rowObject[filter.key] as Array<any>).filter(c => c.id == multiObjectsList[i].id).length > 0) {		
							findAnd = true;		
						
						}
						else {
							findMulti = false;
							//tuhle moznost rusim, protoze vdy bude typ And
							//if (multiObjectsList[i].isOR == false) {
							
							//	findMulti = false;
							//}
						}
					}
					findMulti = findMulti &&  findAnd;
					
					isOk = isOk && findMulti;
				}
			}
		}
		//kontrola filtru group (or)
		if (selFiltersGroup.length > 0) {
			var groups = [];
			//roztřídění podle skupin TADY POUZIT getFiltersByGroups !!!!!!!!!!!!!
			for (var i = 0; i < selFiltersGroup.length; i++) {
				if (groups.indexOf(selFiltersGroup[i].groupId) == -1) {
					groups.push(selFiltersGroup[i].groupId);
				}
			}
			for (var i = 0; i < groups.length; i++) {
				let group = groups[i];
				let rowObject = Object(rowItem);
				let search = (rowObject[group] as string);
				let allGroupValue = [];
				let groupById = selFiltersGroup.filter(c => c.groupId == group);

				for (var g = 0; g < groupById.length; g++) {
					allGroupValue.push(groupById[g].value);
				}
				isOk = isOk && allGroupValue.indexOf(search) != -1;
			}
		}

		return isOk;
	}

	initOptionsColumns() {
		//HEXX puvodni
		//let loadColumns = this.storeFrom(store.state.optionsColumns);
		let loadColumns = this.storeFrom(this.$store.state.optionsColumns);
		let isSelected = false;
		this.optionsColumns = [];
		for (var i = 0; i < this.fieldsBase.length; i++) {
			if (this.fieldsBase[i].optional && this.fieldsBase[i].show != false) {
				isSelected = this.fieldsBase[i].visible || this.fieldsBase[i].visible == undefined;
				if (loadColumns != null) {
					var optionalItem = (loadColumns as Array<any>).filter((c: any) => c.value == this.fieldsBase[i].key)[0];
					if (optionalItem) {
						isSelected = optionalItem.selected;
					}
				}
				if (this.fieldsBase[i].show == undefined || this.fieldsBase[i].show == true) {
					this.optionsColumns.push({ text: this.fieldsBase[i].label, value: this.fieldsBase[i].key, selected: isSelected, defaultVisible: this.fieldsBase[i].visible });
					this.changeVisibility(this.fieldsBase[i].key, isSelected);
				}
				if (this.fieldsBase[i].visible || this.fieldsBase[i].visible == undefined) {
					this.selectedColumns.push(this.fieldsBase[i].key);
					this.selectedColumnsVisibility.push(this.fieldsBase[i].key);
				}
			}
		}
	}

	//z dateTime pickeru dostanu 2020-08-01  převod do čísla 20200801
	prepareForNumber(input: any) {
		let result = 0;
		if (input == null) {
			return -1;
		}
		let text = input as string;
		if (text.length > 8) {
			result = Number(text.split('-').join('').substring(0, 8));
		}
		return result;
	}


	showSettingColumn() {
		//TODO jeste najit lepsi misto kde to ulozit
		this.$store.commit("selectedColumns", { name: this.nameBase, value: this.selectedColumns });
		return this.fieldsBase.find((x: any) => x.optional === true);
	}

	//změna řazení z gridu
	changeOrderGrid(order: any) {
		this.$store.commit("sortBy", { name: this.nameBase, value: order });
		this.sortBy = order;
		this.$forceUpdate();
	}

	changeOrderAscGrid(orderAsc: boolean) {
		this.$store.commit("sortDesc", { name: this.nameBase, value: orderAsc });
		this.sortDesc = orderAsc;
		this.$forceUpdate();
	}

	storeFrom(nameArr: any[]): any {
		let exists = nameArr.find(c => c.name == this.nameBase);
		if (exists != undefined) {
			return exists.value;
		}
		else {
			let exists = nameArr.find(c => c.name == '');
			if (exists != undefined) {
				return exists.value;
			}
		}

	}	

	changeShowDesign(showGrid: boolean) {
		this.isGridShow = showGrid;
		this.$store.commit("isShowGrid", { name: this.nameBase, value: this.isGridShow });
	}

	contextChange() {
		this.$store.commit("perPageTable", { name: this.nameBase, value: this.perPage });
		this.$store.commit("totalRows", { name: this.nameBase, value: this.totalRows });
		this.$store.commit("currentPage", { name: this.nameBase, value: this.currentPage });
		this.$store.commit("sortBy", { name: this.nameBase, value: this.sortBy });
	}

	sortChanged() {
		if ((this.$refs.mainTab as BTable) != undefined) {
			this.$store.commit("sortDesc", { name: this.nameBase, value: (this.$refs.mainTab as BTable).localSortDesc });
		}
	}

	changeVisibilityColumnn(item: any) {
		item.selected = !item.selected;
		this.changeVisibility(item.value, item.selected);
		this.$store.commit("optionsColumns", { name: this.nameBase, value: this.optionsColumns });
	}

	changeVisibility(name: string, isVisible: boolean) {
		let field = this.fieldsBase.filter((c: any) => c.key == name)[0];
		if (name == '') {
			return;
		}

		if (isVisible) {
			if (field.class.indexOf('visibility') != -1) {
				field.class = field.class.replace('collapse', 'visible');
			}
			else {
				field.class = field.class + ' , visibility: visible';
			}
		}
		else {
			if (field.class.indexOf('visibility') != -1) {
				field.class = field.class.replace('visible', 'collapse');
			}
			else {
				field.class = field.class + ' , visibility: collapse';
			}
		}
	}

	//nachystani toolTipu
	initTooltipColumns() {
		this.tooltipsColumns = [];
		for (var i = 0; i < this.fieldsBase.length; i++) {
			if (this.fieldsBase[i].tooltip != undefined) {
				this.tooltipsColumns.push({ text: this.fieldsBase[i].key, value: this.fieldsBase[i].tooltip });
			}
		}
		this.useTooltip = this.tooltipsColumns.length > 0;
	}

	// #region Filtry

	getFiltersByGroups() {
		let selFiltersGroup = this.filterData.filter(c => (c.group && ((!c.selected && c.isNegative) || (c.selected && !c.isNegative))));
		var groups: string[] = [];
		//roztřídění podle skupin
		for (var i = 0; i < selFiltersGroup.length; i++) {
			if (groups.indexOf(selFiltersGroup[i].groupId) == -1) {
				groups.push(selFiltersGroup[i].groupId);
			}
		}
		var result = [];
		for (var i = 0; i < groups.length; i++) {
			result.push(selFiltersGroup.filter(c => c.groupId == groups[i]));
		}
		return result;
	}

	//sezname pro zobrazeni podle skupin
	getFiltersByGroupsForShow() {
		let selFiltersGroup = this.filterData.filter(c => c.group);

		var groups: string[] = [];
		//roztřídění podle skupin
		for (var i = 0; i < selFiltersGroup.length; i++) {
			if (groups.indexOf(selFiltersGroup[i].groupId) == -1) {
				groups.push(selFiltersGroup[i].groupId);
			}
		}
		var result = [];
		for (var i = 0; i < groups.length; i++) {
			result.push(selFiltersGroup.filter(c => c.groupId == groups[i]));
		}
		return result;
	}

	public getSelecteRows(): any {
		return this.selectedRowMain;
	}


	//nastaveni vybranych prvku
	public setSelectedRows(list: any): void {
		this.deselectAll();
		for (var i = 0; i < list.length; i++) {
			this.clickRow(list[i], true);
		}
	}

	// #endregion


		// #region SPOLECNE BaseTLTableBase a BaseTLTableV2


	changeVisibilityFilterSetting() {
		this.showFilterSetting = this.showColumnSetting = false;
		this.$emit('changeShowMenu', false);
	}

	showColumnSettings() {
		this.showColumnSetting = !this.showColumnSetting;
		this.showFilterSetting = false;
		this.$emit('changeShowMenu', this.showColumnSetting);
	}

	showFilterSettings() {
		this.showFilterSetting = !this.showFilterSetting;
		this.showColumnSetting = false;
		this.$emit('changeShowMenu', this.showFilterSetting);
	}
	showFilterOrColumng(): boolean {
		return this.showColumnSetting || this.showFilterSetting;
	}

	prepareFilterSelected(item: any): string {
		if (item.type == 'datetime') {
			return tlISODateTimeToLocalNoSecondsString(item.value);
		}
		else {
			if (item.useOwnEnumsSend) { //vlastni kolekce ve filtru
				var sel = (item.useOwnEnumsSendArray as Array<any>).filter((c: any) => c.value == item.value);
				return sel.length > 0 ? sel[0].text : '';
			}
			else {
				return item.value;
			}
		}
	}

	//popisek do vybranych filtru co se zobrazuji nahore
	prepareFilterDescription(item: any): string {
		if (item.useOwnEnumsSend) { //vlastni kolekce ve filtru
			var sel = (item.useOwnEnumsSendArray as Array<any>).filter((c: any) => c.value == item.value);
			return sel.length > 0 ? sel[0].description : '';
		}
		else {
			return '';
		}
	}

	clearInputFilter(filter: any): void {
		if (filter.type == 'datetime') {
			var actDate = new Date();
			filter.value = filter.moreThan ? new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 0, 0) :
				new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 23, 59);
		}
		else {
			filter.value = '';
		}
	}

	getSelectedGroupFilters() {
		return this.getFiltersByGroups();
	}

	controlDown = false;
	ctrlDownUp(isDown: boolean) {
		this.controlDown = isDown;
	}



	// #endregion SPOLECNE BaseTLTableBase a BaseTLTableV2


	// #region NEXT PAGE  SPOLECNE BaseTLTableBase a BaseTLTableV2

	nextPageShow() {
		return this.countNextPage == 1 ?
			((this.perPage * this.currentPage) < this.totalRows) :
			((this.perPage * this.currentPageCount) < this.totalRows)
		;// && this.scrollBarInDown;
	}

	nextPageTitle() {
		//return this.$t('baseTable.nextPageTitle').toString() + (this.currentPage + 1);
		return this.perPage + this.$t('baseTable.nextPageTitle').toString();
	}

	scrollBarInDown = false;





	//počet všechn záznamů a aktuální stránka
	sumaryAllItemsText() {
		let result = this.totalRows;
		let start = (this.currentPage - 1) * this.perPage + 1;
		let end = (this.currentPage) * this.perPage;
		if (end > this.totalRows) {
			end = this.totalRows;
		}
		
		if (this.totalRows == 0) {
			return this.$t('baseTable.noRecord');
		}
		if (this.countNextPage > 1) {
			let startCount = (this.oldCurrentPage - 1) * this.perPage + 1;
			var endCount = (this.currentPageCount) * this.perPage;
			if (endCount > this.totalRows) {
				endCount = this.totalRows;
			}
			return startCount + '-' + endCount + '/' + result;
		}
		else {
			return start + '-' + end + '/' + result;
		}
	}

        // #endregion NEXTPAGE  SPOLECNE BaseTLTableBase a BaseTLTableV2


	// #region test





	// #endregion

}



